import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M20.87,5H3.13c-.62,0-1.13.51-1.13,1.13v10.74c0,.62.51,1.13,1.13,1.13h17.74c.62,0,1.13-.51,1.13-1.13V6.13c0-.62-.51-1.13-1.13-1.13ZM6.77,10.64c0,.18-.15.33-.33.33h-2.33c-.18,0-.33-.15-.33-.33v-1.52c0-.18.15-.33.33-.33h2.33c.18,0,.33.15.33.33v1.52Z" />
  </>,
  "Creditcard",
);

export default Icon;
